export type ApplicationError =
    | { type: 'UnexpectedError'; originalError?: unknown }
    | { type: 'UnexpectedBody'; originalError?: unknown }
    | { type: 'CaptchaRequired' }
    | { type: 'LoginWithCredentialsFailed' }
    | { type: 'TaxationNotFound' }
    | { type: 'AuthenticationError' }
    | { type: 'RedirectError'; location?: string };

export const unexpectedError = (originalError?: unknown): ApplicationError => ({
    type: 'UnexpectedError',
    originalError,
});

export const unexpectedBody = (originalError?: unknown): ApplicationError => ({
    type: 'UnexpectedBody',
    originalError,
});

export const loginWithCredentialsFailed = (): ApplicationError => ({
    type: 'LoginWithCredentialsFailed',
});

export const captchaRequired = (): ApplicationError => ({
    type: 'CaptchaRequired',
});

export const taxationNotFound = (): ApplicationError => ({
    type: 'TaxationNotFound',
});

export const authenticationError = (): ApplicationError => ({
    type: 'AuthenticationError',
});

export const redirectError = (location?: string): ApplicationError => ({
    type: 'RedirectError',
    location,
});
